var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 41,
    viewBox: "0 0 31 41",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3062 15C21.3062 18.5156 18.4937 21.25 15.0562 21.25C11.5406 21.25 8.80625 18.5156 8.80625 15C8.80625 11.5625 11.5406 8.75 15.0562 8.75C18.4937 8.75 21.3062 11.5625 21.3062 15ZM15.0562 12.5C13.65 12.5 12.5562 13.6719 12.5562 15C12.5562 16.4062 13.65 17.5 15.0562 17.5C16.3844 17.5 17.5562 16.4062 17.5562 15C17.5562 13.6719 16.3844 12.5 15.0562 12.5ZM30.0562 15C30.0562 21.875 20.9156 33.9844 16.8531 39.0625C15.9156 40.2344 14.1187 40.2344 13.1812 39.0625C9.11875 33.9844 0.0562458 21.875 0.0562458 15C0.0562458 6.71875 6.69687 0 15.0562 0C23.3375 0 30.0562 6.71875 30.0562 15ZM15.0562 3.75C8.80625 3.75 3.80625 8.82812 3.80625 15C3.80625 16.0156 4.11875 17.5 4.97812 19.5312C5.75937 21.4062 6.93125 23.5938 8.25937 25.7812C10.525 29.375 13.1031 32.8125 15.0562 35.3125C16.9312 32.8125 19.5094 29.375 21.775 25.7812C23.1031 23.5938 24.275 21.4062 25.0562 19.5312C25.9156 17.5 26.3062 16.0156 26.3062 15C26.3062 8.82812 21.2281 3.75 15.0562 3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryAddressIcon);
export default __webpack_public_path__ + "static/media/delivery_address_icon.fd32a38a0bf241b0d3463a00cfe13dde.svg";
export { ForwardRef as ReactComponent };